export const ERR_NOT_VERIFIED = "not_verified";
export const GMAIL_CONFIMATION_LINK = encodeURI(
  "https://mail.google.com/mail/#search/from:grabjobs+in:anywhere+newer_than:1h",
);
export const OUTLOOK_CONFIRMATION_LINK = encodeURI(
  "https://outlook.live.com/mail/",
);
